const servicePages = [
  {
    slug: "house-washing",
    name: "House Washing",
    metaTitle: "House Washing Clinton NC | Hamilton Pressure Washing",
    metaDescription:
      "Professional house washing in Clinton, NC. Remove algae, mildew, dirt, and grime with safe soft washing from Hamilton Pressure Washing.",
    heroTitle: "House Washing Services in Clinton, NC",
    intro:
      "Our house washing service is designed to safely remove mold, algae, dirt, pollen, and organic buildup from your home's exterior without damaging siding, paint, trim, or landscaping.",
    sections: [
      {
        heading: "Why Homeowners In Clinton, NC Choose Soft House Washing",
        paragraphs: [
          "Traditional high-pressure blasting can damage siding, force water behind panels, and shorten the life of painted surfaces. Our process uses low-pressure application and professional cleaning solutions to break down buildup at the root.",
          "That means your home stays cleaner longer while preserving curb appeal and helping protect your property value in Clinton and nearby communities.",
        ],
      },
      {
        heading: "What We Clean During A House Wash",
        paragraphs: [
          "We clean siding, soffits, fascia, gutters, trim, entry areas, and other exterior surfaces where organic staining and grime collect.",
          "We tailor the process based on your home material, including vinyl siding, painted wood, Hardie board, and other common exterior finishes.",
        ],
      },
      {
        heading: "Local Exterior Cleaning Built For North Carolina Conditions",
        paragraphs: [
          "Humidity and pollen in eastern North Carolina can cause recurring green and black staining. Our treatment is built for local conditions and focuses on long-lasting visual improvement.",
          "If your home has streaking, discoloration, or visible mildew, house washing is one of the fastest ways to make your property look new again.",
        ],
      },
    ],
    includes: [
      "Low-pressure soft wash application",
      "Mildew and algae treatment",
      "Siding and trim rinse-down",
      "Entryway and visible surface touch-up",
      "Final quality walkthrough",
    ],
    faq: [
      {
        question: "Is house washing safe for vinyl siding?",
        answer:
          "Yes. Our soft washing process is specifically designed to clean vinyl siding safely without the damage risk of high pressure.",
      },
      {
        question: "How often should I wash my house in Clinton, NC?",
        answer:
          "Most homes benefit from professional house washing about once per year, depending on shade, moisture, and tree coverage.",
      },
      {
        question: "Will house washing remove green and black staining?",
        answer:
          "Yes. We target common algae, mildew, and organic staining with proper treatment and low-pressure rinsing.",
      },
    ],
  },
  {
    slug: "driveway-cleaning",
    name: "Driveway Cleaning",
    metaTitle: "Driveway Cleaning Clinton NC | Concrete Cleaning",
    metaDescription:
      "Driveway cleaning in Clinton, NC for concrete, pavers, and asphalt. Remove oil stains, dirt, algae, and grime with professional surface cleaning.",
    heroTitle: "Driveway Cleaning In Clinton, NC",
    intro:
      "Your driveway is one of the first things people notice. We remove built-up dirt, algae, tire marks, and stains from concrete, pavers, and other hardscape surfaces to restore a clean, professional look.",
    sections: [
      {
        heading: "Professional Surface Cleaning For Better Results",
        paragraphs: [
          "We use commercial-grade surface cleaners for even, streak-free results across large flat areas. This process provides cleaner and more consistent outcomes than standard wand-only pressure washing.",
          "Our team adjusts pressure and technique based on material type to deliver a deeper clean while protecting the surface.",
        ],
      },
      {
        heading: "Common Driveway Problems We Remove",
        paragraphs: [
          "We target dark buildup, algae, mildew, rust-like staining, dirt accumulation, and grime from daily vehicle traffic.",
          "For many properties in Clinton, driveway cleaning also dramatically improves sidewalks, walkways, and entry pads around the home.",
        ],
      },
      {
        heading: "Improve Curb Appeal And Surface Longevity",
        paragraphs: [
          "Routine driveway cleaning supports safer walking surfaces and helps slow long-term deterioration caused by organic growth and trapped grime.",
          "It is one of the highest-impact exterior cleaning services if you are preparing to sell, host, or simply maintain a polished property.",
        ],
      },
    ],
    includes: [
      "Commercial surface cleaner treatment",
      "Targeted edge cleaning",
      "Stain-focused prep and rinse",
      "Driveway and adjacent walkway wash",
      "Final inspection for consistency",
    ],
    faq: [
      {
        question: "Can you clean concrete and paver driveways?",
        answer:
          "Yes. We clean concrete, pavers, and other hardscape materials with pressure and methods matched to each surface.",
      },
      {
        question: "Will driveway cleaning remove oil stains?",
        answer:
          "Many oil stains can be significantly improved. Results depend on stain age and how deep the contamination has set.",
      },
      {
        question: "How long does driveway cleaning take?",
        answer:
          "Most residential driveways can be completed in a few hours, depending on size and condition.",
      },
    ],
  },
  {
    slug: "gutter-cleaning",
    name: "Gutter Cleaning",
    metaTitle: "Gutter Cleaning Clinton NC | Hamilton Pressure Washing",
    metaDescription:
      "Reliable gutter cleaning in Clinton, NC. We remove debris, clear downspouts, and help protect your home from drainage and water overflow issues.",
    heroTitle: "Gutter Cleaning Services In Clinton, NC",
    intro:
      "Clogged gutters can lead to overflow, wood rot, foundation stress, and siding staining. Our gutter cleaning service helps keep rainwater flowing properly away from your home.",
    sections: [
      {
        heading: "Protect Your Home From Water Damage",
        paragraphs: [
          "When gutters are full of leaves and debris, rainwater can overflow in all the wrong places. That can affect fascia, soffits, landscaping, and even your foundation perimeter.",
          "Our process focuses on full debris removal and reliable downspout flow so your gutter system works the way it should.",
        ],
      },
      {
        heading: "Complete Gutter And Downspout Clearing",
        paragraphs: [
          "We clean out buildup from gutters and flush downspouts to ensure drainage is clear. We also look for common flow issues and surface-level warning signs while we work.",
          "This helps homeowners in Clinton stay ahead of expensive exterior and moisture-related repairs.",
        ],
      },
      {
        heading: "Seasonal Maintenance For Better Performance",
        paragraphs: [
          "Gutter cleaning is especially important during pollen-heavy seasons and after leaf drop. Regular maintenance keeps your roofline cleaner and helps prevent standing water and overflow.",
          "We recommend routine service intervals based on nearby tree coverage and your property's drainage pattern.",
        ],
      },
    ],
    includes: [
      "Gutter debris removal",
      "Downspout flushing and flow check",
      "Roof edge and drainage path cleanup",
      "Basic visual condition check",
      "Cleanup of removed debris",
    ],
    faq: [
      {
        question: "How often should gutters be cleaned?",
        answer:
          "Many homes need gutter cleaning at least twice per year, but heavy tree coverage may require more frequent service.",
      },
      {
        question: "Do you clear clogged downspouts?",
        answer:
          "Yes. Downspout flow is part of our standard process to help ensure full drainage performance.",
      },
      {
        question: "Can clogged gutters cause siding stains?",
        answer:
          "Yes. Overflowing gutters can run dirty water down siding and trim, leaving visible streaking and staining.",
      },
    ],
  },
  {
    slug: "roof-washing",
    name: "Roof Washing",
    metaTitle: "Roof Washing Clinton NC | Soft Wash Roof Cleaning",
    metaDescription:
      "Safe roof washing in Clinton, NC using low-pressure soft wash methods to remove black streaks, algae, and roof stains while protecting shingles.",
    heroTitle: "Roof Washing In Clinton, NC",
    intro:
      "Our roof washing service uses a soft washing process to remove black streaks, algae, and organic staining from roofing surfaces while minimizing risk to shingles and surrounding materials.",
    sections: [
      {
        heading: "Safe Soft Wash Process For Shingle Roofs",
        paragraphs: [
          "High-pressure roof cleaning can cause premature wear. Our low-pressure approach treats and removes biological growth without aggressive blasting.",
          "This helps improve roof appearance and supports longer-term roof health when done correctly and consistently.",
        ],
      },
      {
        heading: "Remove Black Streaks And Organic Growth",
        paragraphs: [
          "Roof streaking is commonly caused by algae and moisture-related buildup. We apply the right treatment to break down growth and restore a cleaner roofline.",
          "A cleaner roof dramatically improves curb appeal and often makes the entire property look newer.",
        ],
      },
      {
        heading: "Local Roof Cleaning You Can Trust",
        paragraphs: [
          "Homes in Clinton, NC deal with heat, humidity, and shade-driven growth patterns. Our process is tailored to those local conditions and surface types.",
          "We focus on safe cleaning outcomes and clear communication throughout the project.",
        ],
      },
    ],
    includes: [
      "Low-pressure roof soft wash application",
      "Algae and organic stain treatment",
      "Controlled rinse process",
      "Protection-minded roof cleaning workflow",
      "Final visual roofline check",
    ],
    faq: [
      {
        question: "Is roof washing safe for asphalt shingles?",
        answer:
          "Yes. Soft washing is the preferred method for many asphalt shingle roofs because it avoids harsh high-pressure impact.",
      },
      {
        question: "Will roof washing remove black streaks?",
        answer:
          "Yes. Black streaks caused by algae can often be effectively treated with proper soft wash methods.",
      },
      {
        question: "How often should a roof be washed?",
        answer:
          "Frequency depends on shade and moisture, but many homes benefit from professional cleaning every 1 to 3 years.",
      },
    ],
  },
  {
    slug: "window-cleaning",
    name: "Window Cleaning",
    metaTitle: "Window Cleaning Clinton NC | Hamilton Pressure Washing",
    metaDescription:
      "Window cleaning in Clinton, NC with streak-free results. Remove film, dirt, pollen, and buildup for clearer views and brighter curb appeal.",
    heroTitle: "Window Cleaning In Clinton, NC",
    intro:
      "Our window cleaning service removes dirt, pollen film, streaks, and environmental buildup so your glass looks clear, bright, and professional from every angle.",
    sections: [
      {
        heading: "Improve Light, Visibility, And Curb Appeal",
        paragraphs: [
          "Clean windows make a huge visual difference for both homes and businesses. They improve natural light indoors and give your exterior a sharper, better-maintained look.",
          "We focus on detail-oriented glass cleaning to reduce haze and spotting for a cleaner finish.",
        ],
      },
      {
        heading: "Professional Window Washing Process",
        paragraphs: [
          "We remove surface buildup and rinse for a clear finish while using techniques suited to your window type and access points.",
          "Our service can be paired with house washing or exterior cleaning projects for a complete curb appeal refresh.",
        ],
      },
      {
        heading: "Consistent Exterior Glass Maintenance",
        paragraphs: [
          "Regular window cleaning keeps buildup from becoming difficult to remove over time. It is especially useful in pollen-heavy and humid seasons in Clinton, NC.",
          "A clean window package helps your property present better year-round.",
        ],
      },
    ],
    includes: [
      "Exterior glass cleaning",
      "Frame and sill wipe-down where accessible",
      "Streak-reduction finishing process",
      "Spot-check for missed residue",
      "Final walkthrough",
    ],
    faq: [
      {
        question: "Do you offer exterior-only window cleaning?",
        answer:
          "Yes. Exterior window cleaning is a common service and can be scheduled as a standalone or bundled appointment.",
      },
      {
        question: "Can window cleaning remove pollen film?",
        answer:
          "Yes. We remove seasonal pollen and typical environmental film that reduces glass clarity.",
      },
      {
        question: "How often should windows be cleaned?",
        answer:
          "Many property owners schedule window cleaning seasonally or every few months depending on exposure and desired appearance.",
      },
    ],
  },
  {
    slug: "commercial-pressure-washing",
    name: "Commercial Pressure Washing",
    metaTitle: "Commercial Pressure Washing Clinton NC | Hamilton Pressure Washing",
    metaDescription:
      "Commercial pressure washing in Clinton, NC for storefronts, offices, sidewalks, and building exteriors. Keep your business clean, safe, and professional.",
    heroTitle: "Commercial Pressure Washing In Clinton, NC",
    intro:
      "We provide commercial pressure washing and soft washing solutions for storefronts, office buildings, churches, multi-unit properties, and other business facilities throughout Clinton and surrounding areas.",
    sections: [
      {
        heading: "Professional Image Starts With A Clean Exterior",
        paragraphs: [
          "Your building exterior is part of your brand. Clean concrete, siding, and entryways signal professionalism and care to customers, tenants, and staff.",
          "We help businesses maintain clean, welcoming properties with reliable scheduling and high-quality results.",
        ],
      },
      {
        heading: "Commercial Cleaning Scope And Flexibility",
        paragraphs: [
          "Our team handles building washes, sidewalks, common areas, entry zones, and other high-visibility exterior surfaces.",
          "We can work around operating hours whenever possible to minimize disruption and keep your business running smoothly.",
        ],
      },
      {
        heading: "Trusted Local Commercial Service Partner",
        paragraphs: [
          "We understand the standards business owners and property managers need from an exterior cleaning contractor: communication, reliability, and consistent outcomes.",
          "If your commercial property needs recurring exterior cleaning in Clinton, NC, we can build a practical maintenance plan.",
        ],
      },
    ],
    includes: [
      "Commercial exterior surface cleaning",
      "Storefront and entry area wash",
      "Sidewalk and walkway pressure washing",
      "Low-pressure soft wash where needed",
      "Flexible scheduling support",
    ],
    faq: [
      {
        question: "Do you service offices and storefronts?",
        answer:
          "Yes. We provide exterior cleaning for retail storefronts, offices, churches, and other commercial properties.",
      },
      {
        question: "Can commercial services be scheduled regularly?",
        answer:
          "Yes. Recurring maintenance schedules are available based on your property needs and traffic level.",
      },
      {
        question: "Do you clean sidewalks and entry areas?",
        answer:
          "Yes. Sidewalks, entries, and high-traffic exterior surfaces are common parts of our commercial work.",
      },
    ],
  },
  {
    slug: "fleet-washing",
    name: "Fleet Washing",
    metaTitle: "Fleet Washing Clinton NC | Commercial Vehicle Cleaning",
    metaDescription:
      "Fleet washing in Clinton, NC for work trucks, trailers, vans, and service vehicles. Keep your company vehicles clean and professional with Hamilton Pressure Washing.",
    heroTitle: "Fleet Washing In Clinton, NC",
    intro:
      "Hamilton Pressure Washing helps local companies keep work trucks, trailers, vans, and service vehicles looking clean, consistent, and professional across Clinton, NC and Sampson County.",
    sections: [
      {
        heading: "Clean Vehicles Support A Professional Brand",
        paragraphs: [
          "Your fleet is often the first impression customers see on the road, in driveways, and at job sites. Regular washing helps vehicles present better and protects your company image.",
          "We clean common fleet surfaces with a practical process built around commercial schedules and real-world vehicle use.",
        ],
      },
      {
        heading: "What Our Fleet Washing Can Include",
        paragraphs: [
          "Fleet washing can include work trucks, vans, trailers, utility bodies, service vehicles, and equipment exteriors depending on your needs.",
          "We focus on road film, dirt, pollen, grime, and exterior buildup that makes vehicles look neglected or inconsistent.",
        ],
      },
      {
        heading: "Flexible Exterior Cleaning For Local Businesses",
        paragraphs: [
          "Businesses in Clinton and Sampson County often pair fleet washing with storefront, sidewalk, or building exterior cleaning for a cleaner overall presence.",
          "Whether you need a one-time cleanup or recurring maintenance, we can recommend a service interval based on fleet size and use.",
        ],
      },
    ],
    includes: [
      "Exterior wash for work vehicles",
      "Road film and grime removal",
      "Trailer and utility body cleaning",
      "Commercial scheduling support",
      "Optional pairing with commercial property washing",
    ],
    faq: [
      {
        question: "What types of fleet vehicles do you wash?",
        answer:
          "We can clean work trucks, vans, trailers, utility bodies, and similar commercial vehicles depending on access, size, and surface condition.",
      },
      {
        question: "Can fleet washing be scheduled regularly?",
        answer:
          "Yes. Many businesses benefit from recurring fleet washing so vehicles stay presentable through pollen, rain, and daily road use.",
      },
      {
        question: "Do you also clean commercial buildings and sidewalks?",
        answer:
          "Yes. Fleet washing can be paired with commercial pressure washing for storefronts, sidewalks, entry areas, and building exteriors.",
      },
      {
        question: "Do you provide fleet washing in Sampson County?",
        answer:
          "Yes. We serve Clinton, NC and nearby Sampson County communities with fleet and commercial exterior cleaning.",
      },
    ],
  },
];

const servicePageBySlug = servicePages.reduce((accumulator, service) => {
  accumulator[service.slug] = service;
  return accumulator;
}, {});

const serviceSlugByName = servicePages.reduce((accumulator, service) => {
  accumulator[service.name] = service.slug;
  return accumulator;
}, {});

serviceSlugByName.Commercial = "commercial-pressure-washing";

export { servicePages, servicePageBySlug, serviceSlugByName };
